import { ReactNode } from 'react';
import { OverlayPortal } from '@/common/components/Overlay/OverlayPortal/OverlayPortal';
import { ToastContainer } from '@/common/components/Toast/ToastContainer';

export const ToastProvider = ({ children }: IProps) => {
  return (
    <>
      {children}
      <OverlayPortal name="toasts" hostName="root">
        <ToastContainer />
      </OverlayPortal>
    </>
  );
};

interface IProps {
  children: ReactNode;
}
